import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
const spaces = {
    narrow: 'gap-8',
    normal: 'gap-16',
};
export const ButtonGroup = (props) => {
    const { children, className = '', isInline = true, space = 'normal' } = props;
    return (_jsx("div", Object.assign({ className: clsx([isInline ? 'inline-flex' : 'flex', 'flex-nowrap'], spaces[space], className) }, { children: children })));
};
